﻿import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as Models from '../models/models';
import {ILogService} from '../core/services/logservice/log.service';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import IAppSettings from '../../iApp.settings';
import { IUserProfile } from '../models/models';
import { UserRequest } from '../models/userrequest.model';

export class UserRepository extends HttpDataServiceBase.DataServiceBase<any> {

    public static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];

    constructor($q: ng.IQService, $http: ng.IHttpService, logger: ILogService, private appSettings: IAppSettings, messageBarService: MessageBarService.MessageBarService)
    {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/users');
    }

    public signUp(signUpRequest: Models.UserSignUpRequest, recaptchaResponse: string):ng.IPromise<any>{

        const signUpUrl =  this.appSettings.apiPath + '/users/signup';
        return this.$http.post(signUpUrl, signUpRequest, { headers: { 'recaptcha': recaptchaResponse } })
        .then((response: ng.IHttpPromiseCallbackArg<Models.UserSignUpResponse>) => this.successHandler(response))
        .catch((error: ng.IHttpPromiseCallbackArg<Models.UserSignUpResponse>): angular.IPromise<string> => this.errorHandler(error));
    }

    public getUserProfile(): ng.IPromise<any> {
        const userProfileUrl =  this.appSettings.apiPath + '/users/profile';
        return this.$http.get(userProfileUrl)
            .then((response: ng.IHttpPromiseCallbackArg<Models.IUserProfile>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<Models.IUserProfile>): angular.IPromise<string> => this.errorHandler(error));
    }

    public getByIds(ids: Array<string>): ng.IPromise<any> {

        const idParameters = [];
        ids.forEach(x => {
            idParameters.push(`ids=${x}`);
        });
        
        const url = `${this.appSettings.apiPath}/users?${idParameters.join("&")}`;
        return this.$http.get(url)
            .then((response: ng.IHttpPromiseCallbackArg<IUserProfile>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>): angular.IPromise<string> => this.errorHandler(error));
    }

    public getSubmissionPrimaryContact(submissionId: string): ng.IPromise<IUserProfile> {
        const url = `${this.appSettings.apiPath}/submission/${submissionId}/primarycontact`;

        return this.get(url);
    }

    public updateById(id: string, userRequest: UserRequest): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/users/${id}`;

        return this.$http.put(url, userRequest)
            .then((response: ng.IHttpPromiseCallbackArg<IUserProfile>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>): angular.IPromise<string> => this.errorHandler(error));
    }
}
